import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  FETCH_TICKET_QUEUE_LIST,
  CREATE_TICKET_QUEUE,
  UPDATE_TICKET_QUEUE,
} from "./types";
import {
  fetchQueryQueuesService,
  fetchTicketQueuesService,
  updateQueryQue,
  updateQueryQueueService,
  updateQueryStatus,
  updateTicketQue,
  updateTicketQueueService,
} from "../../services";
import {
  removeSingleTicketQueue,
  removeTicketQueus,
  selectTicketQueuePage,
  setTicketQueus,
  setUnreadTicketQueCount,
} from "./slice";
import { setAlert } from "../basicSlices";
import { handleLoadQuery } from "../query";
import { store } from "..";
import { PayloadAction } from "@reduxjs/toolkit";

// Action payload: { page?: number, limit?: number, reset?: boolean }
export function* handleLoadTicketQueues(
  action: PayloadAction<{ page?: number; limit?: number; reset?: boolean }>
) {
  try {
    const limit = action.payload?.limit || 10;

    // If caller passed `page`, use it, else load next page from store
    let page = action.payload?.page;
    if (!page) {
      const currentPage: number = yield select(selectTicketQueuePage);
      page = currentPage + 1; // default: next page
    }
    if (action?.payload?.reset) {
      yield put(removeTicketQueus());
    }
    // Call API with pagination params
    const responseData: any = yield call(fetchTicketQueuesService, {
      page,
      limit,
    });
    // Extract fields from response
    const data = responseData?.result?.records?.data || [];
    const total = responseData?.result?.records?.total || 0;
    const hasMore =
      responseData?.result?.records?.last_page !==
      responseData?.result?.records?.current_page;

    // Store in Redux
    yield put(
      setTicketQueus({
        data,
        page,
        hasMore,
      })
    );

    yield put(setUnreadTicketQueCount(total));
  } catch (error: any) {
    // yield put(
    //   setAlert({
    //     text: error?.message,
    //     type: "danger",
    //     title: "Failed to fetch Ticket Queues!",
    //   })
    // );
  }
}

function* handleCreateTicketQueues({
  payload,
}: {
  payload?: { callback?: Function; query_id: string; billing_doc?: any };
} = {}): Generator<any> {
  try {
    const responseData: any = yield call(updateTicketQue, payload);
    if (payload?.query_id) {
      yield handleLoadQuery({ payload: { id: payload?.query_id } });
    }
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to add query.",
      })
    );
  } finally {
    payload?.callback && payload?.callback();
  }
}

function* handleUpdateTicketQueue({
  payload,
}: {
  payload: any;
}): Generator<any> {
  try {
    const responseData: any = yield call(updateTicketQueueService, payload);
    yield handleLoadTicketQueues({
      payload: { page: 1, limit: 10, reset: false },
      type: "dummy",
    });
    if (payload?.query_id) {
      yield handleLoadQuery({ payload: { id: payload?.query_id } });
    }
  } catch (error: any) {
    yield put(
      setAlert({
        text: error?.message,
        type: "danger",
        title: "Failed to update the Query Queue!",
      })
    );
  } finally {
    payload?.callback && payload?.callback();
  }
}

export default function* ticketQueueSaga() {
  yield takeLatest<any>(FETCH_TICKET_QUEUE_LIST, handleLoadTicketQueues);
  yield takeLatest<any>(CREATE_TICKET_QUEUE, handleCreateTicketQueues);
  yield takeLatest<any>(UPDATE_TICKET_QUEUE, handleUpdateTicketQueue);
}
